import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import excelIcon from "../../assets/icons/excel.png";
import { Tooltip } from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { FaFilePdf } from "react-icons/fa";
import AppDataGrid from '../../components/common/AppDataGrid';

const Studentdaywiseattendancereport = () => {
  const userData = sessionStorage.getItem("user");
  const userObj = JSON.parse(userData);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [attendanceData, setAttendanceData] = useState([]);
  const [academic, setAcademic] = useState([]);
  const [classes, setClasses] = useState([]);
  const [sections, setSection] = useState([]);
  const [attendanceDate, setAttendanceDate] = useState("");
  const [attendanceSplit, setAttendanceSplit] = useState([]);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const [form, setForm] = useState({
    academic_year_id: userObj.academic_year_id,
    class_id: "",
    section_id: "",
    attendanceDate: "",
  });

  const exportToPDF = () => {
    if (attendanceData.length === 0) {
      toast.error("No data available to export.");
      return;
    }

    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text("Student Day Wise Attendance Report", 14, 15);

    const tableColumn = ["Roll Number", "Student Name", "AM Attendance", "PM Attendance"];
    const tableRows = attendanceData.map((row) => [
      row.roll_no || "",
      row.student_name || "",
      formatAttendance(row.am_attendance),
      formatAttendance(row.pm_attendance),
    ]);

    autoTable(doc, {
      startY: 20,
      head: [tableColumn],
      body: tableRows,
      styles: { fontSize: 10 },
    });

    doc.save("Day_Wise_Attendance_Report.pdf");
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!attendanceDate) {
      toast.error("Please select a date.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(
        baseUrl + "/studentdaywiseattendancereport/",
        {
          action: "FILTER",
          academic_year_id: form.academic_year_id,
          class_id: form.class_id,
          section_id: form.section_id,
          attendance_date: attendanceDate,
          school_id: userObj.school_id,
        }
      );

      const data = Array.isArray(response.data) ? response.data : [];

      // Directly map morning/afternoon fields to am/pm
      const mapped = data.map((row) => ({
        ...row,
        am_attendance: row.morning_present,
        pm_attendance: row.afternoon_present,
      }));

      setAttendanceData(mapped);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      toast.error("Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };


  const fetchAcademicYears = async () => {
    try {
      const response = await axios.post(baseUrl + "/AcademicYear/", {
        action: "CURRENTREAD",
        school_id: userObj.school_id,
      });
      setAcademic(response.data);
    } catch (error) {
      console.log("Error fetching academic name:", error);
    }
  };

  const fetchClasses = async () => {
    try {
      const response = await axios.post(baseUrl + "/classes/", {
        action: "READ",
        school_id: userObj.school_id,
      });
      setClasses(response.data);
    } catch (error) {
      console.log("Error fetching class name:", error);
    }
  };

  useEffect(() => {
    fetchClasses();
    fetchAcademicYears();
  }, []);

  const fetchSections = async (class_id) => {
    try {
      const response = await axios.post(baseUrl + "/Sections/", {
        action: "DROPDOWNREAD",
        class_id: class_id,
        school_id: userObj.school_id,
       academic_year_id: userObj.academic_year_id
      });
      setSection(response.data);
    } catch (error) {
      console.log("Error fetching section name:", error);
    }
  };

  useEffect(() => {
    fetchSections(form.class_id || 0);
  }, [form.class_id]);

  const handleInputChange = (event) => {
    const { id, value } = event.target;
    setForm((prevForm) => ({
      ...prevForm,
      [id]: value,
    }));
  };

  const columns = [
  {
    field: 'roll_no',
    headerName: 'Roll Number',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    field: 'student_name',
    headerName: 'Student Name',
    flex: 1.5,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    field: 'am_attendance',
    headerName: 'AM Attendance',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      const val = params.value;
      if (val === 'P') {
        return <span style={{ color: 'green' }}>P</span>;
      } else if (val === 'A') {
        return <span style={{ color: 'red' }}>A</span>;
      } else {
        return <span style={{ color: '#888' }}>--</span>; // Not marked
      }
    },
    sortable: true,
  },
  {
    field: 'pm_attendance',
    headerName: 'PM Attendance',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      const val = params.value;
      if (val === 'P') {
        return <span style={{ color: 'green' }}>P</span>;
      } else if (val === 'A') {
        return <span style={{ color: 'red' }}>A</span>;
      } else {
        return <span style={{ color: '#888' }}>--</span>; // Not marked
      }
    },
    sortable: true,
  },
];



  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredRecords = (attendanceData || []).filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      ["admission_number", "student_name", "roll_no", "am_attendance", "pm_attendance"].some(
        (column) =>
          student[column] &&
          String(student[column]).toLowerCase().includes(query)
      ) ||
      (student.date_of_join &&
        student.date_of_join.split(" ")[0].split("-").reverse().join("-").includes(query))
    );
  });


  const exportToExcel = () => {
    if (attendanceData.length === 0) {
      toast.error("No data available to export.");
      return;
    }

    const formattedData = attendanceData.map((row) => ({
      "ROLL NUMBER": row.roll_no,
      "STUDENT NAME": row.student_name,
      "AM ATTENDANCE": formatAttendance(row.am_attendance),
      "PM ATTENDANCE": formatAttendance(row.pm_attendance),
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    worksheet["!cols"] = [
      { wch: 15 },
      { wch: 25 },
      { wch: 15 },
      { wch: 15 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "DayWiseReport");
    XLSX.writeFile(workbook, "Student_Day_Wise_Attendance_Report.xlsx");
  };

  const formatAttendance = (status) => {
    if (!status) return "--";
    return status === "P" ? "Present" : status === "A" ? "Absent" : "--";
  };

  return (
    
   
       
        <div className="pageBody">
            <ToastContainer />
          <Container fluid>
            <Card>
              <Card.Body>
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col xs={12}>
                      <h6 className="commonSectionTitle">
                        Day Wise Attendance Report
                      </h6>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6} lg={3} xxl={3}>
                      <div className="commonInput">
                        <Form.Group>
                          <Form.Label>Attendance Date</Form.Label>
                          <Form.Control
                            type="date"
                            id="date_picker"
                            value={attendanceDate}
                            onChange={(e) => setAttendanceDate(e.target.value)}
                            required
                          />
                        </Form.Group>
                      </div>
                    </Col>

                    <Col xs={12} md={6} lg={4} xxl={3}>
                      <div className="commonInput">
                        <Form.Group>
                          <Form.Label>
                            Class
                          </Form.Label>
                          <select
                            className="form-select"
                            required
                            id="class_id"
                            value={form.class_id}
                            onChange={handleInputChange}
                          >
                            <option value="" disabled hidden>Select Class</option>
                            {(classes || [])
                              .filter(
                                (classItem) => classItem.is_active === "Active"
                              ) // Filter to include only active classes
                              .map((classItem) => (
                                <option
                                  key={classItem.class_id}
                                  value={classItem.class_id}
                                >
                                  {classItem.class_name}
                                </option>
                              ))}
                          </select>
                        </Form.Group>
                      </div>
                    </Col>

                    <Col xs={12} md={6} lg={3} xxl={3}>
                      <div className="commonInput">
                        <Form.Group>
                          <Form.Label>Section</Form.Label>
                          <select
                            className="form-select"
                            id="section_id"
                            value={form.section_id}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="" disabled hidden>Select Section</option>
                            {(sections || []).map((sectionItem) => (
                              <option
                                key={sectionItem.section_id}
                                value={sectionItem.section_id}
                              >
                                {sectionItem.section_name}
                              </option>
                            ))}
                          </select>
                        </Form.Group>
                      </div>
                    </Col>
                    <Col xs={12} md={6} lg={3} xxl={3}>
                      <div className="d-flex justify-content-end gap-3 mt-4">
                        <Button
                          type="button"
                          variant="primary"
                          className="btn-info clearBtn"
                          onClick={() => {
                            setForm({
                              academic_year_id: userObj.academic_year_id,
                              class_id: "",
                              section_id: "",
                              attendanceDate: "",
                            });
                            setAttendanceDate("");
                            setAttendanceData([]);
                            setSearchQuery("");
                          }}
                        >
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          variant="primary"
                          className="btn-success primaryBtn"
                        >
                          Search
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </Card.Body>
            </Card>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                className="form-control form-control-sm w-25"
                onChange={handleSearchChange}
              />
              <div>
                <Button
                  className="btnMain"
                  variant="success"
                  onClick={exportToExcel}
                  style={{ marginRight: "10px" }}
                >
                  <img
                    src={excelIcon}
                    alt="Download Excel"
                    style={{ width: "20px", marginRight: "5px" }}
                  />

                </Button>
                <Button
                  className="btnMain"
                  variant="danger"
                  onClick={exportToPDF}
                >
                  <FaFilePdf style={{ marginRight: "5px" }} />
                </Button>
              </div>
            </div>

            <div
              className="commonTable height100 mt-2"
              style={{ maxHeight: "70vh", overflowY: "auto" }}
            >
              <div className="tableBody">

                <AppDataGrid
  rows={filteredRecords.length ? filteredRecords : []}
  columns={columns}
  getRowId={(row) => row.roll_no || `${row.student_name}-${row.am_attendance}-${row.pm_attendance}`}
  pageSizeOptions={[10, 20, 50]}
  showToolbar={false}
  pagination
  density="compact"
  maxHeight={400}
/>

              </div>
            </div>
          </Container>
        </div>
     
  );
};

export default Studentdaywiseattendancereport;
